<template>
  <el-dialog
    v-if="visible"
    :modal-append-to-body="false"
    :modal="false"
    :visible.sync="visible"
    show-close
    width="700px"
    :title="$l('INDEX.form_add_identify_No') || '添加识别单号'"
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <IdentifyTable ref="identify" :identifyJson="identifyJson" />

    <span slot="footer">
      <el-button size="small" @click="close()">{{
        $l('INDEX.btn_cancel') || '取消'
      }}</el-button>
      <el-button type="primary" size="small" @click="confirm()">{{
        $l('INDEX.btn_confirm') || '确认'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import IdentifyTable from './table.vue'
export default {
  components: { IdentifyTable },
  props: {
    visible: { type: Boolean, default: false },
    identifyJson: { type: String, default: '' },
  },
  methods: {
    async confirm() {
      const validResult = await this.$refs.identify.validEvent()
      if (!validResult) return

      const data = this.$refs.identify.getTableData()

      let identifyJson = ''
      if (data) {
        identifyJson = JSON.stringify(data)
      }
      this.$emit('update:identifyJson', identifyJson)
      this.$emit('change', identifyJson)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
